import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { isEmpty } from 'lodash-es';
import { RelateIds } from '../../../../../lists/relate-ids';
import { FileService } from '../../../../../services/file/file.service';
import { WidgetService } from '../../../../../services/widget.service';
import { NotificationService } from '../../../../../services/notification.service';
import { filter } from 'rxjs/operators';
import { data_get, OptionalValue } from '../../../../utils/common';

@Component({
  selector: 'app-files',
  templateUrl: './files.component.html',
  styleUrls: ['./files.component.scss'],
})
export class FilesComponent implements OnInit {


  public bShowLoader: any = {
    'submit': false
  };

  public is_Empty = isEmpty;
  public bSubmitted: boolean = false;
  public arFiles : any[] = [];
  public strRelatedId: any = RelateIds;
  public arRecordDetails: any = [];
  public arRequestData: any = [];
  public isFileDropped: boolean = false;
  public isFileUploaded: boolean = false;
  public strDescription: string = '';
  public arFilesList: any = [];
  public bEdited: boolean = false;

  includeInJobReport: boolean = false;

  get moduleName(): OptionalValue<string> {
    return data_get(this.arRecordDetails, 'module');
  }

  @HostListener('window:keyup.esc') onKeyUp() {
    this.cancelDialog();
  }

  constructor(
    public dialogRef: MatDialogRef<FilesComponent>,
    private fileService: FileService,
    public widgetService: WidgetService,
    private notifService: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {    // Store record details
    this.arRecordDetails = data;
  }

  ngOnInit() {
    this.dialogRef.backdropClick().subscribe(_ => {
      this.cancelDialog();
    });
  }


  onFileChange(objData) {
    // If file is valid
    if (objData.target.files && objData.target.files.length) {
      this.isFileDropped = true;
      const arSelectedFiles: File[] = Array.from(objData.target.files);

      let intRemaining = arSelectedFiles.length;

      arSelectedFiles.forEach((file: File) => {
        const sanitizedFile: File = this.fileService.sanitizeFilename(file);

        // check if the uploaded file is valid
        if (!this.fileService.hasValidUploadFile(sanitizedFile)) {
          this.notifService.notifyWarning('invalid_file_type');
          intRemaining--;
          if (intRemaining === 0) {
            this.isFileDropped = false;
            this.isFileUploaded = this.arFiles.length > 0;
          }
          return;
        }

        // if file size is less than 30mb
        if (sanitizedFile.size/1024/1024 < 30) {
          this.fileService.upload(sanitizedFile).subscribe((response) => {
            this.arFiles.push({
              'name': sanitizedFile.name,
              'size': sanitizedFile.size / 1024,
              'type': sanitizedFile.type,
              'upload_name' : response['filename']
            });

            intRemaining--;
            if (intRemaining === 0) {
              this.isFileDropped = false;
              this.isFileUploaded = this.arFiles.length > 0;
            }
          }, _ => {
            intRemaining--;
            if (intRemaining === 0) {
              this.isFileDropped = false;
              this.isFileUploaded = this.arFiles.length > 0;
            }
          });
        } else {
          this.notifService.sendNotification('not_allowed', 'invalid_file_size', 'warning');
          intRemaining--;
          if (intRemaining === 0) {
            this.isFileDropped = false;
            this.isFileUploaded = this.arFiles.length > 0;
          }
        }
      });
    }
  }

  /**
   * For Cancel button
   */
  cancelDialog(): void {
    if (this.bEdited) {
      // Pop-up modal for confirmation
      this.notifService.sendConfirmation('confirm_cancel')
      .pipe(
        filter(confirmatation => (confirmatation.answer === true)),
      )
      .subscribe(() => {
        this.dialogRef.close({ status: 'cancel' });
      });
    } else {
      this.dialogRef.close({ status: 'cancel' });
    }
  }

   /*
   * Submit the form's data to the Activities table
   * and send the email id not draft
   */
  onSubmit() {
    // Set submitted to true
    this.bSubmitted = true;

    // Check if file is set and is uploaded
    if (this.isFileUploaded == false || this.arFiles.length === 0) {
      this.notifService.sendNotification('upload_failed', 'file_invalid', 'warning');
    // Check character count of description
    } else if (this.strDescription.length > 1024) {
      this.notifService.sendNotification('upload_failed', 'max_character', 'warning');
    } else {
      // Setup request data per file
      const arRequests = this.arFiles.map((fileItem: any) => ({
        module_id: this.arRecordDetails.record_id,
        module_field: this.strRelatedId[this.arRecordDetails.module],
        description: this.strDescription,
        file: fileItem,
        module: this.arRecordDetails.module,
        include_in_job_report: this.includeInJobReport,
      }));

      this.bSubmitted = false;
      this.dialogRef.close({ status: 'save', request: arRequests });
    }
  }

  /**
   * Mark as edited
   */
  markAsEdited(): void {
    this.bEdited = true;
  }

}
